<template>

    <v-page-body>

        <transition name="modal">
            <v-modal-member-invite v-if="showModal === 'invite'" @created="getMemberInvites" />
            <v-modal-member-invite-delete v-if="showModal === 'invite-delete'" :invite="selectedInvite" @deleted="getMemberInvites" />
        </transition>

        <v-page-filters floating>
            <v-tab-bar>
                <a :class="{ active: this.tab === 'members' }" href="#" @click.prevent="getMembers">Members</a>
                <a :class="{ active: this.tab === 'invites' }" href="#" @click.prevent="getMemberInvites">Invites</a>
            </v-tab-bar>
            <div></div>
            <v-button size="sm" @click.native="inviteMember">Invite Member</v-button>
        </v-page-filters>

        <div v-if="tab === 'members'">
            <v-notice v-if="!members.length" title="No Members Found" message="There are no members in this company yet." />
            <v-list v-else>
                <v-member v-for="member in members" :key="member.id" :member="member" />
            </v-list>
        </div>

        <div v-if="tab === 'invites'">
            <v-notice v-if="!invites.length"
                :title="'No Invites Found'"
                :message="'There are no invites for this company yet.'">
            </v-notice>
            <v-list v-else>
                <v-member-invite v-for="invite in invites" :key="invite.id" :invite="invite" @delete="deleteInvite" />
            </v-list>
        </div>

    </v-page-body>

</template>

<script>

import CompanyApi from '@api/CompanyApi';
import ModalMemberInvite from '@modals/member/ModalMemberInvite';
import ModalMemberInviteDelete from '@modals/member/ModalMemberInviteDelete';
import Member from './components/Member';
import MemberInvite from './components/MemberInvite';

export default {

    components: {
        'v-member': Member,
        'v-member-invite': MemberInvite,
        'v-modal-member-invite': ModalMemberInvite,
        'v-modal-member-invite-delete': ModalMemberInviteDelete,
    },

    data() {
        return {
            tab: 'members',
            members: [],
            invites: [],
            selectedInvite: null,
        }
    },

    mounted() {
        this.getMembers();
    },

    methods: {

        getMembers() {
            this.$store.commit('loading', true);
            CompanyApi.getMembers(this.$store.getters.company.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.members = response.data.data;
                    this.tab = 'members';
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        getMemberInvites() {
            this.$store.commit('loading', true);
            CompanyApi.getMemberInvites(this.$store.getters.company.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.invites = response.data.data;
                    this.tab = 'invites';
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        inviteMember() {
            this.$store.commit('showModal', 'invite');
        },

        deleteInvite(invite) {
            this.selectedInvite = invite;
            this.$store.commit('showModal', 'invite-delete');
        },

    },

}

</script>